<template>
	<div
		class="text-slogan d-flex justify-content-center align-items-center p-5 cursor-pointer card card-slogan text-center"
		:class="selected ? 'active' : ''"
		:style="`background-image: url(${coverImage})`"
	>
		<slot @click="console.log('teste click')"></slot>
	</div>
</template>

<script>
	export default {
		props: {
			selected: {
				type: Boolean,
				default: false,
			},
			coverImage: {
				type: String,
				required: false,
				default: "",
			},
		},
		methods: {
			emitSelectedSlogan() {
				this.$emit("updateSelectedSlogan", this.slogan);
			},
			updateSlogan: _.debounce(function (ev) {
				let newSlogan = { ...this.slogan };
				newSlogan.text = ev.target.textContent;
				this.emitUpdateSlogan(newSlogan);
			}, 1600),
			emitUpdateSlogan(newSlogan) {
				this.$emit("updateSlogan", newSlogan);
			},
		},
	};
</script>

<style scoped>
	.card-slogan {
		border: 4px solid #fff;
		border-radius: 8px;

		transition: all 600ms;
		min-height: 200px;
		font-size: 1.3rem;
		color: #fff;

		background-position: center center;
		background-size: cover;
		background-blend-mode: darken;
		background-repeat: no-repeat;
	}
	.card-slogan::after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: 4px;
		background: #000;
		opacity: 0.22;
		z-index: 1;
	}
	.card-slogan p {
		z-index: 2;
	}
	.card-slogan.active {
		border: 4px solid var(--main-color);
	}
</style>


// WEBPACK FOOTER //
// src/components/molecules/CardStepWizardSloganHome.vue